import React from "react";
import Svg, { Path, G, Defs, ClipPath } from "react-native-svg";

function Plus({ color = "#E40046" }) {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M12.9069 12.8065L20.6164 12.8063C21.118 12.8064 21.5234 12.401 21.5233 11.8994C21.5233 11.3979 21.1179 10.9925 20.6164 10.9925L12.9068 10.9926L12.907 3.28308C12.9069 2.78148 12.5016 2.37619 12.0001 2.3762C11.4985 2.37609 11.0931 2.7815 11.0932 3.2831L11.093 10.9926L3.38346 10.9928C2.88186 10.9927 2.47644 11.3981 2.47656 11.8997C2.47644 12.1498 2.5779 12.3769 2.74209 12.5411C2.90627 12.7053 3.13329 12.8066 3.38344 12.8066L11.093 12.8064L11.0929 20.5161C11.0929 20.7662 11.1942 20.9932 11.3584 21.1574C11.5226 21.3216 11.7496 21.4229 11.9998 21.4229C12.5014 21.4231 12.9068 21.0176 12.9067 20.516L12.9069 12.8065Z"
        fill={color}
      />
    </Svg>
  );
}

export default Plus;
